<template>
    <b-field :label="label" id="time_selector_container" class="input-selector-container">
      <div class="collection">
        <treeselect
          name="hour"
          :options="hours"
          v-model="hour"
          placeholder="Horas"
        />
        <treeselect
          name="minute"
          :options="minutes"
          v-model="minute"
          placeholder="Minutos"
        />
      </div>
    </b-field>
</template>

<script>
export default {
  name: "TimeSelector",
  props: ["value", "label"],
  data: () => ({
    hour: null,
    minute: null,
    hours: new Array(13)
      .fill()
      .map((item, index) => ({ id: index, label: `${index} horas` })),
    minutes: new Array(60)
      .fill()
      .map((item, index) => ({ id: index, label: `${index} minutos` })),
  }),
  watch: {
    value: function (value) {
      this.computeTimes();
    },
    minute: function () {
      this.onChangeFn();
    },
    hour: function () {
      this.onChangeFn();
    },
  },
  mounted() {
    this.computeTimes();
  },
  methods: {
    computeTimes() {
      if (!this.value) {
        return;
      }
      const hour = Math.floor(this.value / 60);
      const minute = Math.floor(this.value - hour * 60);
      if (this.hour == hour && this.minute == minute) {
        return;
      }
      this.hour = Math.floor(hour);
      this.minute = minute;
    },
    onChangeFn() {
      const time = (this.hour || 0) * 60 + (this.minute || 0);
      if (this.value === time) {
        return;
      }
      this.$emit("input", time);
    },
  },
};
</script>